/* @flow */
/* global Blob, window */

import stepsJson from '../data/stepData.json';
import { downloadSVGImage } from '../utils';
// import { getNextFieldsByStep, getStepByField, downloadBlob, downloadSVGImage } from '../utils';

import { actions as modalActions, constants as modalConstants } from './modal';

import type { CurrentUserType } from './global';

export type DesignObjectResponseType = {
  id: number,
  recordName: string,
  recordType: string,
  timestamp: number,
  timeStampString: string,
  trackingId: string,
  userId: string,
};

export type DesignResponseType = {
  data: {
    [key: string]: any,
  },
  message: {
    type: "SUCCESS" | "ERROR",
  },
};

// Constants
export const constants = {
  STEP_FORWARD: 'Design/STEP_FORWARD',
  STEP_BACKWARD: 'Design/STEP_BACKWARD',
  STEP_RESET: 'Design/STEP_RESET',
  AUTO_COMPLETE: 'Design/AUTO_COMPLETE',
  RENAME_DESIGN: 'Design/RENAME_DESIGN',
  NEW_DESIGN: 'Design/NEW_DESIGN',
  ERROR: 'Design/ERROR',
  API_ERROR: 'Design/API_ERROR',
  EVALUATE_ERROR: 'Design/EVALULATE_ERROR',
  UPDATE: 'Design/UPDATE',
  EVALUATE: 'Design/EVALUATE',
  CHANGE_VALUE: 'Design/CHANGE_VALUE',
  PENDING: 'Design/PENDING',
  JUMP_STEP: 'Design/JUMP_STEP',
  VALIDATION_ERROR: 'Design/VALIDATION_ERROR',
  REQUEST_CHART_DATA: 'Design/REQUEST_CHART_DATA',
  CANCEL_CHART_DATA: 'Design/CANCEL_CHART_DATA',
  RECEIVE_CHART_DATA: 'Design/RECEIVE_CHART_DATA',
  DOWNLOAD_PDF: 'Design/DOWNLOAD_PDF',
  REQUEST_PDF: 'Design/REQUEST_PDF',
  CANCEL_PDF: 'Design/CANCEL_PDF',
  RECEIVE_PDF: 'Design/RECEIVE_PDF',

  REQUEST_SCHEMATIC: 'Design/REQUEST_SCHEMATIC',
  RECEIVE_SCHEMATIC: 'Design/RECEIVE_SCHEMATIC',
  DOWNLOAD_SCHEMATIC: 'Design/DOWNLOAD_SCHEMATIC',

  CHECK_FET_CONFIG: 'Design/CHECK_FET_CONFIG',
  RECEIVE_FET_CONFIG: 'Design/RECEIVE_FET_CONFIG',

  SCROLL_TO_TOP: 'Design/SCROLL_TO_TOP',
  EXPORT_BOM_EXCEL: 'Design/EXPORT_BOM_EXCEL',

  SAVE_DESIGN: 'Design/SAVE_DESIGN',
  OPEN_DESIGN: 'Design/OPEN_DESIGN',
  FETCH_DESIGNS: 'Design/FETCH_DESIGNS',
  RECEIVE_DESIGNS: 'Design/RECEIVE_DESIGNS',

  FETCH_DESIGN: 'Design/FETCH_DESIGN',
  RECEIVE_DESIGN: 'Design/RECEIVE_DESIGN',

  REQUEST_USER: 'Design/REQUEST_USER',
  RECEIVE_USER: 'Design/RECEIVE_USER',

  REQUEST_PARTS: 'Design/REQUEST_PARTS',
  RECEIVE_PARTS: 'Design/RECEIVE_PARTS',
};

export type ConstantsType = $Keys<typeof constants>;
export type ActionType = { type: ConstantsType };
export type ActionFunctionType = () => { payload?: Object | string, type: ConstantsType };

export const undoableActions: Array<string> = [
  constants.STEP_FORWARD,
  constants.STEP_BACKWARD,
  constants.STEP_RESET,
  constants.AUTO_COMPLETE,
  constants.RENAME_DESIGN,
  constants.UPDATE,
  constants.JUMP_STEP,
];

// Action Creators
export const actions = {
  stepForward: () => ({ type: constants.STEP_FORWARD }),
  stepBackward: () => ({ type: constants.STEP_BACKWARD }),
  stepReset: () => ({ type: constants.STEP_RESET }),
  autoComplete: () => ({ type: constants.AUTO_COMPLETE }),
  pendingAction: () => ({ type: constants.PENDING }),
  jumpStep: (payload: string, silent?: boolean = false) => ({ type: constants.JUMP_STEP, payload, silent }),
  renameDesign: (payload: {}) => ({ type: constants.RENAME_DESIGN, data: payload }),
  newDesign: (silent: boolean = false) => ({ type: constants.NEW_DESIGN, payload: silent }),

  error: (payload: {}) => ({ type: constants.ERROR, payload }),
  apiError: (payload: {}) => ({ type: constants.API_ERROR, payload }),
  evaluateError: (payload: {}) => ({ type: constants.EVALUATE_ERROR, payload }),
  receiveData: (payload: {}) => ({ type: constants.UPDATE, payload }),
  evaluateData: (payload: {}) => ({ type: constants.EVALUATE, payload }),
  validationError: (payload: {}) => ({ type: constants.VALIDATION_ERROR, payload }),
  changeValue: (payload: {}) => ({ type: constants.CHANGE_VALUE, payload }),

  requestChartData: () => ({ type: constants.REQUEST_CHART_DATA }),
  cancelChartData: () => ({ type: constants.CANCEL_CHART_DATA }),
  receiveChartData: (payload: {}) => ({ type: constants.RECEIVE_CHART_DATA, payload }),

  downloadPDF: () => ({ type: constants.DOWNLOAD_PDF }),
  requestPDF: () => ({ type: constants.REQUEST_PDF }),
  cancelPDF: () => ({ type: constants.CANCEL_PDF }),
  receivePDF: (payload: any, fileName: string) => ({ type: constants.RECEIVE_PDF, payload, fileName }),

  requestUser: () => ({ type: constants.REQUEST_USER }),
  receiveUser: (payload: CurrentUserType) => ({ type: constants.RECEIVE_USER, payload }),

  requestSchematic: () => ({ type: constants.REQUEST_SCHEMATIC }),
  receiveSchematic: (payload: {}) => ({ type: constants.RECEIVE_SCHEMATIC, payload }),
  downloadSchematic: () => ({ type: constants.DOWNLOAD_SCHEMATIC }),
  saveSchematicImage: (data: string, filename: string) => downloadSVGImage(data, filename),

  checkFETConfig: () => ({ type: constants.CHECK_FET_CONFIG }),
  receiveFETConfig: (payload: [boolean, boolean, boolean]) => ({ type: constants.RECEIVE_FET_CONFIG, payload }),

  scrollTop: () => () => window.scrollTo(0, 0),
  exportBOMToExcel: () => ({ type: constants.EXPORT_BOM_EXCEL }),

  saveDesign: (payload: string) => ({ type: constants.SAVE_DESIGN, payload }),
  openDesign: () => ({ type: constants.OPEN_DESIGN }),

  fetchDesign: (payload: number) => ({ type: constants.FETCH_DESIGN, payload }),
  receiveDesign: (payload: Object) => ({ type: constants.RECEIVE_DESIGN, payload }),
  fetchDesigns: () => ({ type: constants.FETCH_DESIGNS }),
  receiveDesigns: (data: Object) => modalActions.showModal({
    modalType: modalConstants.MODAL_OPEN_DESIGN,
    modalProps: {
      data,
      // onOpenDesign: (id: number) => dispatch(actions.fetchDesign(id)),
    },
  }),
  requestParts: () => ({ type: constants.REQUEST_PARTS }),
  receiveParts: (payload: { [key: string]: string }) => ({ type: constants.RECEIVE_PARTS, payload }),
};

export const stepData = stepsJson;

export type SchematicType = {
  data: string,
  hasData: boolean,
  loading: boolean,
};

export type ChartType = {
  data: Object,
  hasData: boolean,
  loading: boolean,
};

type RangeType = {
  max: number,
  min: number,
};

export type FieldDataType = {
  currentValue?: any,
  defaultValue?: any,
  hasRangeValue?: boolean,
  hasSelectionValue?: boolean,
  rangeValue?: RangeType,
  selectionValue?: number,
  step?: string,
};

export type RecordDataType = {
  id: number,
  recordName: string,
  trackingId: string,
};

export type StateType = {
  changedFields: KeyedObject<boolean>,
  chartData: boolean,
  currentStep: string,
  dirtyFields: KeyedObject<boolean>,
  errors: {},
  evaluating: KeyedObject<boolean>,
  fetConfig: [string, string, string],
  id: ?string,
  initialValues: KeyedObject<Object>,
  loading: boolean,
  name: string,
  openingDesign: boolean,
  savingDesign: boolean,
  schematic: SchematicType,
  stepStatus: any,
  values: KeyedObject<FieldDataType>,
};

export default { constants, actions };



// WEBPACK FOOTER //
// ./src/actions/design.js